"use client";

import dynamic from "next/dynamic";
import BirthToolFormShell from "@/components/tool-shell/BirthToolFormShell";
import { useDeferredToolActivation } from "@/components/tool-shell/useDeferredToolActivation";

// Bundle-size discipline (2026-07-16 trim pass): KaalSarpDoshClient pulls the
// full BirthDetailsForm + PlaceAutocomplete + result/offer stack. Loading it
// via next/dynamic keeps that stack out of the route's initial JS and shares
// ONE copy with the other deferred calculator islands. The page's H1/SEO stay
// server-rendered; the shell reserves the swap height (rule 58).
const KaalSarpToolIsland = dynamic(() => import("./KaalSarpDoshClient"), {
  ssr: false,
  loading: () => (
    <div className="max-w-md mx-auto">
      <BirthToolFormShell />
    </div>
  ),
});

export default function DeferredKaalSarpDoshClient() {
  const { ready, activate } = useDeferredToolActivation();

  if (ready) return <KaalSarpToolIsland />;

  return (
    <div className="max-w-md mx-auto">
      <BirthToolFormShell submitLabel="Check Kaal Sarp Dosh" onActivate={activate} />
    </div>
  );
}
